export default __webpack_public_path__ + "static/media/bank.eee593d8.svg";